import { ItemTransferDuration } from 'entities/ticket/ui/direction-detail'
import { TransferDefault } from 'entities/ticket/ui/direction-detail/ui/transfer-default'
import { TransferNight } from 'entities/ticket/ui/direction-detail/ui/transfer-night'

export const TransferDetail = (data?: ItemTransferDuration) => {
  return (
    <>
      {data?.isNight ? (
        <TransferNight data={data} />
      ) : (
        <div>
          <TransferDefault data={data} />
        </div>
      )}
    </>
  )
}
